var _ellipse, _path, _path2, _g, _g2, _g3, _g4, _path3, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstitutionHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1030,
    height: 304,
    viewBox: "440 40 1030 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 953.999,
    cy: 191.998,
    rx: 452,
    ry: 152,
    fill: "#AD5D4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M675.95 105.473L684.563 96.4492H687.947V115.521L695.022 112.753L707.43 112.343L709.788 114.496L694.817 126.391L709.788 138.388L707.225 140.951L695.228 140.336L687.947 137.362V145.976L679.539 154.999H675.95V137.567L668.772 140.541L656.673 141.156L654.109 138.593L669.183 126.391L654.314 114.496L656.468 112.138L668.978 112.548L675.95 115.521V105.473Z",
    fill: "#EFE7D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.95 105.473L1239.56 96.4492H1242.95V115.521L1250.02 112.753L1262.43 112.343L1264.79 114.496L1249.82 126.391L1264.79 138.388L1262.22 140.951L1250.23 140.336L1242.95 137.362V145.976L1234.54 154.999H1230.95V137.567L1223.77 140.541L1211.67 141.156L1209.11 138.593L1224.18 126.391L1209.31 114.496L1211.47 112.138L1223.98 112.548L1230.95 115.521V105.473Z",
    fill: "#EFE7D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1576_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.668 75.43L828.926 95.096C816.988 94.6457 805.782 94.5966 795.308 94.9487C794.978 98.0318 794.558 103.513 794.047 111.393C793.647 119.17 793.36 123.963 793.185 125.771C805.183 124.622 814.806 124.184 822.055 124.458L824.589 142.166C812.639 142.035 801.898 142.377 792.367 143.192C791.74 159.82 791.4 174.485 791.348 187.185L769.854 183.973C770.292 166.697 770.791 150.651 771.35 135.835C771.909 121.019 773.495 101.598 776.109 77.5727C794.441 75.4888 812.294 74.7746 829.668 75.43Z",
    fill: "#FDC042"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1576_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.028 185.128L880.83 162.813L856.975 163.256L850.245 193.198L827.892 190.793L859.038 75.4405L888.576 78.6413L907.181 187.55L884.028 185.128ZM871.861 96.6834L860.705 146.213L878.635 145.962L871.861 96.6834Z",
    fill: "#FDC042"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1576_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.555 117.483C956.967 112.263 957.682 107.893 957.699 104.373C957.716 100.853 956.77 97.9683 954.861 95.7189C952.953 93.3629 950.452 92.1774 947.358 92.1623C944.372 92.1478 941.858 93.6289 939.817 96.6056C937.775 99.5824 936.745 102.991 936.727 106.831C936.69 114.297 940.926 120.718 949.433 126.093C957.939 131.681 963.733 135.709 966.814 138.178C969.896 140.646 972.071 142.897 973.341 144.93C976.516 150.172 978.09 155.566 978.063 161.113C978.016 170.713 974.725 178.377 968.19 184.105C961.763 189.727 954.496 192.518 946.389 192.479C936.789 192.432 928.756 188.339 922.289 180.201C917.624 174.312 913.34 166.984 909.436 158.218L924.992 150.774C927.414 157.186 930.428 162.641 934.033 167.138C937.745 171.53 941.681 173.736 945.841 173.756C948.507 173.769 950.911 172.927 953.053 171.231C955.195 169.535 956.274 166.98 956.29 163.567C956.307 160.047 954.99 156.787 952.338 153.787C949.686 150.788 946.127 147.73 941.663 144.615C937.198 141.5 933.743 138.977 931.299 137.045C928.856 135.006 926.148 132.433 923.177 129.325C917.553 123.324 914.763 115.684 914.809 106.404C914.854 97.0172 918.146 89.1932 924.683 82.9317C931.221 76.5635 938.97 73.4012 947.93 73.4449C956.889 73.4886 964.393 76.9919 970.439 83.9547C976.591 90.9182 979.65 98.0798 979.614 105.44C979.579 112.693 978.162 118.926 975.363 124.139L955.555 117.483Z",
    fill: "#FDC042"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1576_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1039.74 185.232L1035.79 163.037L1011.97 164.281L1006.24 194.432L983.823 192.779L1011.08 76.4457L1040.71 78.6528L1062.96 186.875L1039.74 185.232ZM1024.61 97.246L1015.12 147.123L1033.03 146.269L1024.61 97.246Z",
    fill: "#FDC042"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.58 116.74L1067.21 115.222C1067.66 102.834 1069.26 87.7499 1072.02 69.9699L1091.04 75.2638C1086.99 88.594 1084.5 102.419 1083.58 116.74Z",
    fill: "#FDC042"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1576_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1146.54 113.884C1147.73 108.61 1148.27 104.214 1148.14 100.697C1148.01 97.179 1146.94 94.3364 1144.94 92.1688C1142.93 89.8947 1140.38 88.8147 1137.29 88.929C1134.31 89.0393 1131.86 90.6242 1129.94 93.6837C1128.03 96.7432 1127.14 100.192 1127.28 104.029C1127.56 111.491 1132.06 117.729 1140.78 122.743C1149.52 127.971 1155.47 131.753 1158.66 134.091C1161.84 136.428 1164.11 138.586 1165.46 140.564C1168.85 145.669 1170.65 150.993 1170.85 156.536C1171.21 166.129 1168.24 173.924 1161.95 179.92C1155.76 185.806 1148.62 188.899 1140.52 189.198C1130.93 189.553 1122.73 185.8 1115.93 177.939C1111.02 172.25 1106.43 165.108 1102.17 156.513L1117.4 148.424C1120.09 154.73 1123.32 160.054 1127.11 164.396C1131.01 168.629 1135.03 170.668 1139.19 170.515C1141.85 170.416 1144.22 169.475 1146.29 167.69C1148.36 165.906 1149.33 163.309 1149.2 159.898C1149.07 156.38 1147.62 153.178 1144.85 150.292C1142.07 147.406 1138.39 144.5 1133.8 141.574C1129.2 138.648 1125.65 136.271 1123.12 134.443C1120.6 132.509 1117.79 130.051 1114.69 127.07C1108.82 121.31 1105.71 113.793 1105.37 104.519C1105.02 95.1386 1107.98 87.1838 1114.25 80.6544C1120.52 74.0185 1128.13 70.535 1137.08 70.204C1146.04 69.8731 1153.68 73.0596 1160.01 79.7637C1166.45 86.4638 1169.8 93.4913 1170.08 100.846C1170.34 108.095 1169.19 114.382 1166.61 119.707L1146.54 113.884Z",
    fill: "#FDC042"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1576_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.893 293.536C495.117 292.645 487.677 290.188 481.574 286.166C475.504 282.146 471.037 276.834 468.175 270.228C465.312 263.623 464.318 256.013 465.192 247.398C465.821 241.212 467.283 235.831 469.58 231.255C471.91 226.682 474.844 222.922 478.382 219.977C481.953 217.035 485.911 214.95 490.256 213.723C494.605 212.463 499.127 212.072 503.823 212.548C508.746 213.048 512.926 214.258 516.363 216.178C519.799 218.097 522.533 220.665 524.562 223.881L527.824 216.409L541.183 217.766L537.917 249.925L520.186 248.124C520.558 241.88 519.763 237.464 517.801 234.876C515.871 232.291 513.141 230.82 509.611 230.461C507.021 230.198 504.518 230.68 502.103 231.907C499.72 233.138 497.68 235.188 495.981 238.059C494.315 240.932 493.244 244.717 492.767 249.413C492.063 256.343 493.321 261.837 496.541 265.894C499.796 269.922 504.695 272.268 511.237 272.933C515.091 273.324 518.929 273.059 522.753 272.139C526.576 271.218 530.212 269.575 533.658 267.21L534.911 267.926L532.829 288.426C528.793 290.797 524.15 292.371 518.902 293.146C513.689 293.893 508.686 294.023 503.893 293.536Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.544 300.972C577.531 300.315 570.736 298.141 565.159 294.451C559.618 290.73 555.52 285.74 552.865 279.48C550.21 273.22 549.22 265.97 549.896 257.729C550.576 249.424 552.736 242.399 556.375 236.655C560.017 230.879 564.875 226.606 570.948 223.838C577.054 221.072 584.113 220.018 592.127 220.675C600.173 221.335 606.966 223.525 612.508 227.245C618.049 230.966 622.146 235.972 624.798 242.264C627.453 248.524 628.44 255.807 627.759 264.113C627.084 272.353 624.926 279.346 621.287 285.09C617.648 290.834 612.792 295.09 606.719 297.858C600.648 300.594 593.59 301.632 585.544 300.972ZM586.92 284.183C590.554 284.481 593.506 282.73 595.778 278.932C598.049 275.133 599.499 269.39 600.13 261.701C600.76 254.012 600.264 248.108 598.642 243.991C597.02 239.873 594.392 237.665 590.758 237.367C587.125 237.069 584.172 238.82 581.901 242.618C579.63 246.417 578.18 252.16 577.549 259.849C576.919 267.538 577.415 273.442 579.037 277.559C580.659 281.677 583.287 283.885 586.92 284.183Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.405 306.822L663.466 260.789L661.779 288.326L669.577 288.803L668.547 305.618L637.063 303.689L638.093 286.875L645.891 287.352L648.584 243.392L640.786 242.914L641.816 226.1L676.663 228.235L700.7 274.273L702.39 246.688L694.592 246.21L695.622 229.396L727.106 231.325L726.076 248.139L718.278 247.661L714.555 308.436L687.405 306.822Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.929 312.561C768.749 312.304 763.677 311.278 759.711 309.484C755.747 307.658 752.619 305.312 750.327 302.448L747.521 310.004L734.105 309.446L735.192 283.297L753.389 284.053C753.85 287.852 755.608 291.036 758.661 293.607C761.716 296.145 765.65 297.514 770.463 297.714C773.098 297.823 775.152 297.388 776.627 296.406C778.102 295.393 778.879 293.959 778.956 292.105C779.04 290.088 778.306 288.527 776.756 287.42C775.205 286.313 773.125 285.412 770.515 284.717C767.905 284.022 765.034 283.332 761.902 282.648C758.77 281.964 755.647 281.068 752.533 279.961C749.419 278.855 746.584 277.303 744.028 275.307C741.472 273.311 739.464 270.67 738.004 267.384C736.546 264.065 735.922 259.869 736.133 254.795C736.337 249.884 737.686 245.64 740.181 242.062C742.708 238.486 746.226 235.765 750.734 233.9C755.243 232.035 760.587 231.231 766.766 231.487C772.295 231.717 776.881 232.706 780.522 234.454C784.164 236.202 787.094 238.588 789.314 241.613L792.121 234.057L805.537 234.615L804.49 259.788L785.903 259.015C785.121 255.106 783.358 252.051 780.615 249.852C777.904 247.654 774.695 246.478 770.987 246.324C768.353 246.215 766.234 246.631 764.631 247.575C763.029 248.486 762.189 249.9 762.109 251.819C762.035 253.608 762.775 255.007 764.329 256.017C765.883 257.026 767.966 257.878 770.576 258.573C773.186 259.268 776.056 259.99 779.185 260.74C782.314 261.489 785.434 262.466 788.544 263.67C791.654 264.874 794.486 266.507 797.039 268.568C799.594 270.597 801.601 273.254 803.061 276.54C804.52 279.826 805.148 283.941 804.942 288.885C804.62 296.625 801.798 302.601 796.475 306.81C791.152 311.02 783.97 312.937 774.929 312.561Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.719 313.044L828.103 296.203L842.26 296.525L843.286 251.518L834.548 251.318L832.22 267.725L816.111 267.357L816.848 235.041L895.832 236.843L895.095 269.159L878.986 268.791L877.408 252.296L868.67 252.097L867.644 297.104L881.8 297.427L881.416 314.269L827.719 313.044Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.499 314.575L904.621 297.729L912.922 297.789L913.241 253.748L904.94 253.688L905.062 236.842L947.053 237.146L946.931 253.991L938.63 253.931L938.312 297.973L946.612 298.033L946.49 314.879L904.499 314.575Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.806 314.916L969.666 298.071L983.825 297.953L983.45 252.935L974.71 253.008L972.894 269.478L956.782 269.613L956.512 237.29L1035.51 236.631L1035.78 268.954L1019.67 269.089L1017.58 252.65L1008.84 252.723L1009.22 297.741L1023.37 297.623L1023.52 314.468L969.806 314.916Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.72 314.418C1077.75 314.727 1069.16 312.201 1062.96 306.84C1056.78 301.478 1053.52 292.712 1053.18 280.542L1052.41 253.112L1044.6 253.332L1044.12 236.493L1085.36 235.33L1085.84 252.169L1077.79 252.396L1078.56 279.876C1078.85 290.158 1083.26 295.179 1091.78 294.939C1095.85 294.824 1098.84 293.405 1100.75 290.681C1102.69 287.956 1103.59 284.12 1103.45 279.174L1102.68 251.695L1094.62 251.922L1094.15 235.083L1126.32 234.176L1126.79 251.015L1118.98 251.235L1119.81 280.618C1120.43 302.55 1110.06 313.816 1088.72 314.418Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.87 310.888L1150.07 294.061L1164.21 293.382L1162.05 248.414L1153.32 248.834L1152.16 265.363L1136.06 266.137L1134.51 233.85L1213.42 230.057L1214.97 262.344L1198.88 263.118L1196.14 246.775L1187.41 247.195L1189.57 292.163L1203.71 291.483L1204.52 308.309L1150.87 310.888Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.57 306.98L1226.5 290.168L1234.78 289.641L1231.98 245.687L1223.7 246.214L1222.63 229.403L1264.54 226.734L1265.61 243.545L1257.32 244.073L1260.12 288.027L1268.41 287.499L1269.48 304.311L1227.57 306.98Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.5 301.917C1312.48 302.554 1305.43 301.499 1299.33 298.751C1293.26 295.969 1288.42 291.701 1284.79 285.948C1281.17 280.195 1279.03 273.198 1278.37 264.956C1277.71 256.648 1278.71 249.368 1281.38 243.115C1284.05 236.829 1288.16 231.832 1293.71 228.125C1299.29 224.415 1306.09 222.242 1314.11 221.604C1322.16 220.964 1329.21 222.035 1335.28 224.818C1341.35 227.601 1346.19 231.885 1349.82 237.67C1353.45 243.423 1355.59 250.453 1356.25 258.76C1356.91 267.002 1355.9 274.25 1353.23 280.504C1350.56 286.757 1346.45 291.738 1340.9 295.445C1335.35 299.119 1328.54 301.277 1320.5 301.917ZM1319.16 285.124C1322.8 284.835 1325.43 282.634 1327.06 278.52C1328.69 274.406 1329.2 268.504 1328.59 260.813C1327.98 253.123 1326.54 247.376 1324.28 243.572C1322.02 239.768 1319.07 238.01 1315.44 238.299C1311.8 238.589 1309.17 240.79 1307.54 244.904C1305.9 249.017 1305.39 254.92 1306.01 262.61C1306.62 270.301 1308.06 276.048 1310.32 279.852C1312.58 283.656 1315.53 285.413 1319.16 285.124Z",
    fill: "#EFE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.98 291.343L1390.96 249.749L1393.71 277.2L1401.49 276.42L1403.17 293.181L1371.78 296.33L1370.1 279.569L1377.88 278.789L1373.48 234.966L1365.71 235.746L1364.02 218.984L1398.76 215.499L1429.88 257.083L1427.12 229.584L1419.34 230.364L1417.66 213.603L1449.05 210.453L1450.73 227.215L1442.95 227.995L1449.03 288.579L1421.98 291.343Z",
    fill: "#EFE7D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1576_44",
    x: 769.444,
    y: 73.3191,
    width: 65.2236,
    height: 120.151,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.270588 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1576_44"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1576_44",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1576_44",
    x: 827.85,
    y: 74.8201,
    width: 86.7363,
    height: 124.608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.270588 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1576_44"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1576_44",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1576_44",
    x: 909.27,
    y: 73.2593,
    width: 75.5,
    height: 124.379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.270588 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1576_44"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1576_44",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1576_44",
    x: 982.44,
    y: 75.8433,
    width: 85.5996,
    height: 123.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.270588 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1576_44"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1576_44",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1576_44",
    x: 1099.03,
    y: 69.0281,
    width: 79.2695,
    height: 126.541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.270588 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1576_44"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1576_44",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1576_44",
    x: 456.95,
    y: 209.021,
    width: 1003.86,
    height: 114.591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.270588 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1576_44"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1576_44",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstitutionHero);
export default __webpack_public_path__ + "static/media/ConstitutionHero.8f617e65359f54f1bc1c8708396a48d1.svg";
export { ForwardRef as ReactComponent };